import { TicketProcessingStateEnum } from "@/api/hausify";
import { createHausifyApi } from "@/api/hausifyClient";
import { createAppAsyncThunk } from "@/store/createAppAsyncThunk";
import { updateTicketAsync } from "../../ticketApi";
import type { Ticket } from "../../ticketSharedTypes";

interface UpdateTicketParams {
  id: string;
  data: Partial<Ticket>;
}

interface TaskAcceptParams {
  assigneeId: number;
  ticket: Ticket;
}

interface TaskCompleteParams {
  ticket: Ticket;
  taskComplete: boolean;
  assigneeId: number;
}

export const fetchTicketByIdThunk = createAppAsyncThunk(
  "ticket/currentTicket/fetch",
  async (id: string) => {
    const response = await createHausifyApi().getTicket(id);
    return response.data;
  },
);

export const updateTicketByIdThunk = createAppAsyncThunk(
  "ticket/update",
  async ({ id, data }: UpdateTicketParams, { dispatch }) => {
    try {
      const response = await updateTicketAsync(id, data);
      return response.data;
    } catch (error) {
      console.error(error);
      await dispatch(fetchTicketByIdThunk(id));
      return undefined;
    }
  },
);

// specific ticket-manager operations
export const taskAcceptThunk = createAppAsyncThunk(
  "ticket/ticket-detail/ticket-manager/task-accept",
  async ({ assigneeId, ticket }: TaskAcceptParams, { dispatch }) => {
    try {
      const ticketCopy: Partial<Ticket> = {
        ...ticket,
        assigneeIds: [...(ticket.assigneeIds || []), assigneeId],
        processingState: TicketProcessingStateEnum.InProgress,
      };

      await dispatch(
        updateTicketByIdThunk({ id: ticket.id, data: ticketCopy }),
      );
    } catch (e) {
      console.error(e);
    }
  },
);

export const taskCompleteThunk = createAppAsyncThunk(
  "ticket/ticket-detail/ticket-manager/task-complete",
  async (
    { ticket, taskComplete, assigneeId }: TaskCompleteParams,
    { dispatch },
  ) => {
    const baseTicket: Partial<Ticket> = {
      ...ticket,
      assigneeIds: (ticket.assigneeIds || []).filter(
        (id: number) => id !== assigneeId,
      ),
    };

    const ticketCopy: Partial<Ticket> = {
      ...baseTicket,
      processingState: taskComplete
        ? TicketProcessingStateEnum.WorkDone
        : TicketProcessingStateEnum.New,
    };

    await dispatch(updateTicketByIdThunk({ id: ticket.id, data: ticketCopy }));
  },
);
